import { defineAction, number, object, string } from '~/prix'
import { point } from '~/prix/types/presets/geoJson'
import streetViewReverseGeocodingAction from './streetViewReverseGeocoding.action.json'
import any from '~/prix/types/any'

const streetViewReverseGeocodingDefinition = defineAction({
  ...streetViewReverseGeocodingAction,

  input: object({
    point: point(),
  }),
  output: object({
    primaryResult: object({
      id: number(),
      name: string(),
      distance: string(),
      path: any(),
      pointOnStreet: point(),
      pointOnStreetHeading: any(),
    }).isOptional(),
    secondaryResult: object({
      id: number(),
      name: string(),
      distance: string(),
      path: any(),
      pointOnStreet: point(),
      pointOnStreetHeading: any(),
    }).isOptional(),
  }),
})

export default streetViewReverseGeocodingDefinition
